// @flow

import React, {useContext} from 'react';
import Experiment from '@homeaway/react-experiment';

import StayContext from '../../context/StayContext';
import SystemContext from '../../context/SystemContext';
import {Alert} from '../../molecules/baseline/baseline';
import translate from '../../../utils/translations';

import './IpmHostInfo.less';

type Props = {
    translations: Object,
};

export const IpmHostInfo = ({translations}: Props) => {
    const {
        system: {humanReadableBrandName},
    } = useContext(SystemContext);

    const {
        stay: {
            booking: {isPrimaryGuest},
            unit: {hostName, integratedPropertyManager},
        },
    } = useContext(StayContext);

    const hostInfo = translate(
        translations,
        'trav-dash/trav-home',
        'messages',
        hostName
            ? 'th.inbox.conversation.ipm.host.info.with.hostname'
            : 'th.inbox.conversation.ipm.host.info.without.hostname',
        {
            hostName,
            brandName: humanReadableBrandName,
        }
    );

    if (isPrimaryGuest && integratedPropertyManager) {
        return (
            <Experiment name={'vrbo_ipm_static_messaging'} variant={'on'}>
                <Alert
                    className="IpmHostInfo"
                    subtle
                    svgClassName="text-info"
                    svgMarkup=""
                >
                    <p
                        dangerouslySetInnerHTML={{
                            __html: hostInfo,
                        }}
                    />
                </Alert>
            </Experiment>
        );
    }
    return null;
};
